export const en = {
  translations: {
    title0_1: "Welcome to",
    title0_2: "the ",
    title0_3: "world of industry 4.0",
    checkOurOffer0_1: "Check our ",
    checkOurOffer0_2: "offer",
    checkOurOffer0_3: " below!",
    st1_0_title_1: "Virtual Diagnostic Models ",
    st1_0_title_2: "(DDP-Ortho)",
    st1_0: "A universal system of digital diagnostic models. Ready-made analyzes and tools for diagnosis and treatment planning for orthodontists. ",
    st1_1: "Compatible with the needs of implantological and surgical diagnostics. ",
    st1_2: "3D Biomechanics according to Giorgio Fiorelli. Navigated workflow options for 3D prints (CAD/CAM) Fully compatible with all intraoral scanners. Patient data processing platform.",
    st1_3: "",
    st1_4: "",
    st1_5: "",

    section_title_2: "Digital diagnostic models",
    title1_0: "A system of virtual diagnostic models for dentists. The models contain information about the patient. There are three types of models to use depending on your needs.",
    title1_1: "",
    bt1_0_0: "",
    bt1_0: "",
    bt1_1: "The DDP-Ortho diagnostic model system allows you to store diagnostics and other important information about the patient in one place - inside the model file.",
    bt1_2: "",
    bt1_3: "During the preparation of the model, anatomical details are introduced, which enables the automation of many diagnostic procedures and treatment planning:",
    bt1_4: "",
    bt1_5: "",
    bt1_6: "Model Basic: includes model analyses, cefalo, notes, photos, measurements and is a complete digital documentation of the case. ",
    bt1_7: "SemiPro model: includes the functionality of the Basic version, extended with a virtual setup. ",
    bt1_8: "Pro model: includes the functionality of the SemiPro version, extended by mapping the shapes of tooth roots. ",
    bt1_9: "The free DDP-Ortho app is required to use the models. The system is compatible with DDS-Pro software for surgeons and implantologists and the Ortonet practice management system. ",
    bt1_10: "",
    bt1_11: "",
    bt1_12: "",
    bt1_13: "",
    bt1_14: "",
    bt1_14_1: "",
    bt1_15_0: "The most important purposes of using DDP-Ortho models:",
    bt1_15: "",
    bt1_16: "diagnostics, planning and visualization of treatment goals (including 3D set-up), ",
    bt1_17: "3D biomechanical correctness checking of the planned medical action",
    bt1_18: "creating diagnostic digital documentation of the patient, ",
    bt1_19: "designing the position of orthodontic brackets, ",
    bt1_20: "preparation of an aligner treatment plan, ",
    bt1_21: "planning surgical and implantological treatment. ",
    bt1_22_1: "",
    bt1_22: "The source of data for the production of models are intraoral scans or impressions/models provided for scanning in the technical laboratory.",
    bt1_23_0: "",
    bt1_23_1: "",
    bt1_23: "DDP-Ortho models can be prepared as part of an order in a laboratory or directly by a doctor or technician. The DTS software allows for many other uses of the models.",


    section_title_1: 'DDP-Ortho Software',
    title2_0: "Free, medically CE certified software for orthodontic specialists.",
    title2_1: "It includes digital patient documentation, automatic model analysis, 3D biomechanics, cephalometry, virtual set-up, visualization of treatment goals, planning of aligner treatment and indirect orthodontic brackets placement or hybrid treatment.",
    title2_2: "",

    st2_0: "Free, medically CE certified software for orthodontists. ",
    st2_1: "Complete diagnostics and treatment planning. ",
    st2_2: "Full digital patient documentation. ",
    st2_3: "3D Biomechanics according to Giorgio Fiorelli. ",
    st2_4: "Automatic calculation of model analyses, individualized cephalometry analyzis, virtual set-up, planning of aligner treatment, with fixed braces or hybrid. Compliance with guidelines for transmitting digital medical records to patients. Windows and Mac OSX version.",
    st2_5: "",
    st2_6: "",
    st2_7: "",

    bt2_0: "DDP-Ortho is a complete solution for orthodontic practices. ",
    bt2_1: "All documentation elements are available in one file. The software works with models saved in the DDP-Ortho format.",
    bt2_2: "",
    bt2_3: "Main functionalities:",
    bt2_4: "DDP-Ortho ",
    bt2_5: "virtual diagnostic model the software offers:",
    bt2_6: "automatic model analysis, ",
    bt2_7: "any measurements, ",
    bt2_8: "attaching and editing photos, ",
    bt2_9: "text notes, ",
    bt2_10: "virtual set-up with many visualization options, ",
    bt2_11: "virtual articulator, ",
    bt2_12: "virtual face bow, ",
    bt2_13: "3D Biomechanics Planner according to Giorgio Fiorelli, ",
    bt2_14: "cephalometric analyzes with a built-in editor, ",
    bt2_15: "related treatment support services: ",
    bt2_16: "patient data exchange platform between specialists like orthodontists, implantologists, surgeons, prosthetists, GPs.",
    bt2_16_0: "positioning of orthodonic brackets with the indirect placement method, ",
    bt2_16_1: "a complete solution for planning and implementing aligner treatment, ",
    bt2_16_2: "platform for exchanging information between specialists (orthodontist, dentist, prosthodontist, surgeon). ",
    bt2_17_0: "",
    bt2_17: "DDP-Ortho software: has CE medical certification, is multilingual, available for Windows and Mac OS X operating systems.",
    bt2_18: "The lifetime free license also includes subsequent updates. DDP-Ortho provides support and assistance in implementing work in the office.",
    st3_0: "Planning of implantological templates, including zygomatic ones, along with simultaneous osteotomies, TAD's and indirect surgical splints. ",
    st3_1: "Volumetric analysis of the airways.",
    st3_2: "Free, universal DICOM file viewer. CE medically certified software.",
    st3_3: "Versions for Windows and MacOS X",


    section_title_0: 'DDS-Pro Software',
    title3_0: 'Planning of implant drill guides and surgical splints.',
    title3_1: 'Includes a free universal DICOM file viewer.',
    title3_2: '',
    bt3_0_0: "",
    bt3_0: "",
    bt3_1: 'DDS-Pro software is addressed to medical specialists or technicians. Includes the design and manufacture of surgical drill guides and surgical splints. It enables interdisciplinary cooperation (orthodontics, digital "smile design").',
    bt3_2: "Key features of the DDS-Pro software:",
    bt3_3: "planning the position of implants with the generation of implantological drill guides, including zygomatic ones, along with simultaneous osteotomy procedures, TAD's temporary anchorage and surgical splints,",
    bt3_4: "advanced DICOM file viewing, ",
    bt3_5: "filtering and generating 3D structures from DICOM files, ",
    bt3_6: "guided insertion of orthodontic implants for simultaneous installation of TADs, ",
    bt3_7: "digital smile design tool with wax-up, ",
    bt3_8: "creating patient documentation (photos, cephaloanalysis, measurements), ",
    bt3_9: "building your own editable implant library, ",
    bt3_10: "using ready-made implant libraries, ",
    bt3_11_0: "planning and simulation of the results of surgical procedures with splints for procedures, ",
    bt3_11_1: "3D volumetric analysis of the airways, ",
    bt3_11_2: "checking compliance of the geometry of tools planned for use with clinical conditions, ",
    bt3_11_3: "software compatible with models in the DDP-Ortho standard. ",
    bt3_12: "",
    bt3_13: "DDS-Pro is medically CE certified, includes many language versions of the interface, works on the Windows and MacOS X platforms. Free registration and various license options available. After registration, work in Viewer mode, it can be used as free and advanced DICOM file viewer. Extended Professional licenses. Usage costs are kept to a minimum in accordance with the pay-per-use principle (without any fixed fees). Comfortable work confirmed by many years of stable operation of users around the world. Technical support and access to a dedicated laboratory service. The system is compatible with DDP-Ortho software for orthodontists and the Ortonet practice management system.",
    bt3_14: "DDS-pro ",
    bt3_15: "comfortable. ",

    st4_0: "A complete management system for any dental practice. ",
    st4_1: "Diagnostic and treatment planning tools. ",
    st4_2: "Interdisciplinary consultation options. ",
    st4_3: "Delegating planning and clinical tasks. ",
    st4_4: "HELO mobile application.",
    st4_5: "Data in the cloud.",
    st4_6: "",
    st4_7: "",
    st4_8: "",

    section_title_4: 'Ortonet Software',
    title4_0: "A complete system for managing any dental practice. Delegating planning and clinical tasks. It includes a patient database, diagnostic analyses, calendar, interdisciplinary consultation, CRM, all HELO options, task delegation and many other functions. Data is stored in the cloud.",
    title4_1: "",
    title4_2: "",
    title4_3: "",
    
    
    bt4_0: "",
    bt4_1: "Ortonet is software dedicated to dental practices of any specialty - it contains typical diagnostic, planning, treatment support and supervision functionalities as well as advanced specialized 3D diagnostic and communication tools (DDP-Ortho, DDS-Pro, HELO, DDP-Ortho-Lite).",
    bt4_2: "Selected features:",
    bt4_3_0: "diagnostic and treatment planning tools based on the DDP-Ortho standard, ",
    bt4_3_1: "",
    bt4_3_2: "",
    bt4_4: "built-in DICOM file viewer, ",
    bt4_5: "advanced administration of patient flow and documentation, ",
    bt4_6: "system for delegating planning and clinical tasks, ",
    bt4_7: "treatment monitoring with the HELO application, ",
    bt4_8: "facilitating communication with the patient or among practice employees, ",
    bt4_8_0: "automation of patient service processes, ",
    bt4_8_1: "simple management of patient data with access from anywhere (cloud), ",
    bt4_8_2: ".stl file browser, ",
    bt4_11: "full compliance with the requirements of Electronic Medical Records. ",
    bt4_9: "",
    bt4_10:"Ortonet works on the Windows platform, is multilingual, and several licensing options are possible.",



    st5_0: "Software for doctors and technicians. ",
    st5_1: "Creating virtual diagnostic models from multiple data sources. ",
    st5_2: "Designing splints and jigs for indirect bracket placement, preparing models for 3D printing. ",
    st5_3: '"In-House" aligner production option. ',
    st5_4: "Individual retention design (coming soon)",


    section_title_3: 'DTS Software',
    title5_0: "Software for technicians and dentists. It allows you to create virtual models for dentistry from any source, preparation of overlay treatment, preparation of indirect bonding of fixed appliances, individual retention.",
    title5_1: "",
    title5_2: "",
    bt5_0: "DTS - Digital Technical Studio - software for doctors, technicians, 3D printing service points, digital assistants or clinicians. It has been proven in over 200,000 cases (as of 2023). It works in the SaaS model (pay as you use). An excellent specialized alternative to expensive licenses and overly complex programs. Tools with intuitive, guided and easy use, divided into logical modules. Each module can function as a selected independent tool:",
    bt5_1: "",
    bt5_2: "",
    bt5_3: "",
    bt5_4: "",
    bt5_5: "",
    bt5_6: "Dental Model Builder (DMB) - for creating a diagnostic model: from a raw file scan to a ready-to-print 3D model. ",
    bt5_7: "Diagnostic Model Editor (DME) - for creating 3D diagnostic models with Set-Up option, ",
    bt5_8_0: "",
    bt5_8_1: "",
    bt5_8_2: "Indirect Bracket Placement (IPA - Individually Projected Apparatus) - for designing rails (jigs or thermoformable plates) for the indirect method of placement brackets, ",
    bt5_9: "Aligners Planner (AP) - for planning aligner treatment, ",
    bt5_10: "Retainer Planner (RP) - for designing individual retention In practice. ",
    bt5_11: "",
    bt5_12: "Digital Technical Studio allows you to work independently with result files from intraoral scanners (.stl, .ply, .obj). It can be used by a digital assistant or technician directly in the office. It is also a tool for a cooperating laboratory or 3D printing services. An optimal payment system without fixed costs (pay-per-use) guarantees the lowest cost of use. Each module can be purchased and used independently. A free trial license allows you to try the software before purchasing. Our technical support greatly facilitates easy implementation.",
    bt5_13_0: 'From RAW',
    bt5_13_1: 'Intra-oral',
    bt5_13_2: 'scan',
    bt5_14_0: 'to usable .stl',
    bt5_14_1: 'and 3D printing',
    bt5_15_0: 'Diagnostic Model',
    bt5_15_1: 'production',
    bt5_16: 'Basic',
    bt5_17: 'SemiPro',
    bt5_18_0: 'Aligners and IPA',
    bt5_18_1: 'Planing and Production',

    submit: "Submit",
    st6_0: 'IPA (Individually Projected Appliance)',
    st6_1: 'Precise and efficient digital indirect bracket bonding system. ',
    st6_2: 'Individual retention design (coming soon).',
    st6_3: '',
    st6_4: '',
    st6_5: '',

    section_title_5: 'Indirect bracket placement',
    title6_0: 'IPA (Individually Projected Appliances)',
    title6_1: '',
    title6_2: 'Precise and effective digital transfer technique for orthodontic brackets.',
    title6_3: '',
    bt6_0: '',
    bt6_1: 'IPA is a technique prepared for the most demanding doctors. Compatibility with DDP-Ortho models ensures automatic positioning of brackets on the teeth with the possibility of additional positioning by a doctor. The planned position of the brackets is perfectly transferred to the patient\'s teeth. It is possible to delegate diagnostic tasks and treatment planning to designated people under the supervision of a doctor. ',
    bt6_2: '',
    bt6_3: 'Functionalities of the IPA technique: ',
    bt6_4: '3D visualization of brackets, ',
    bt6_5: 'automatic positioning of brackets adapted to the case, ',
    bt6_6: 'adjustment of the bracket position by the doctor in accordance with preferences and treatment plan, ',
    bt6_7: 'free access to the base of the lock for reliable polymerization of the glue. ',
    bt6_8_0: '',
    bt6_8: 'The IPA technique is one related to the functionalities of the DDP-Ortho software. It is available as a laboratory service or for self-preparation in the office using available software.',
    bt6_9: '',
    bt6_10: '',
    bt6_11: '',

    st7_0: 'Ready-made splints for treating the patients. ',
    st7_1: 'Also a digital system design and production of splints for laboratories and medical practices. ',
    st7_2: 'Option of own production (In-House).',
    st7_3: '',


    section_title_6: 'Digital A-ligner system',
    title7_0: 'A complete, fully customized digital system for planning and producing aligners. ',
    title7_1: 'The easy-to-do set-up allows you to implement the treatment concept without unnecessary "clean checks". ',
    title7_2: 'A-ligner can be used as a stage of hybrid treatment. ',
    title7_3: '',
    bt7_0: '',
    bt7_1: 'A-Ligner is a digital system based on DDP-Ortho virtual diagnostic models. It enables planning aligner treatment with full control of tooth movements (speed, order), use of attachments, elastics, etc. ',
    bt7_2: '',
    bt7_3: 'System specifications: ',
    bt7_4: "full individualization of the designed spplints (tooth displacement and rotation values, shape of attachments, movement sequences, additional elements), ",
    bt7_5: "editable on-site in the office, set-up is available without unnecessary contact with a technician, ",
    bt7_6: 'the entire planning and production process can take place in practice or be outsourced to a designated workshop, ',
    bt7_7: 'recommended use of "Retainer For Life", i.e. preparing each 5th splint in the series as a retainer that can be used for long-term use in the event of accidental interruption of treatment, ',
    bt7_8: 'aligners are delivered in short series of 5 pieces, which eliminates the problem of mismatching splints in long series delivered in advance, ',
    bt7_9: 'flexible payment in stages for the delivered series of aligners, without having to pay for the entire treatment upfront. ',
    bt7_10: '',
    bt7_11_0: '',
    bt7_11: 'The A-Ligner system is operated as part of the free DDP-Ortho software. Preparation of a series of working models for the production of overlays is carried out by the software. You can become a manufacturer of your own A-ligners.',
    bt7_12: '',



    ShowMore: "More information",
    Download: "Download ",
    ContactUs: "Contact Us",
    Close: 'Close',
    GoToTop: 'Go to top',
    Email: 'Email',
    Password: 'Password',
    Login: 'Log In',
    ResetPassword: 'Reset password',
    GoBack: 'Go back',
    SendPassword: 'SendPassword',

    // contact element
    FillAllFields: 'Please, fill all fields',
    Error: 'Internal Server Error',
    MessageSend: 'Message send',
    ServerErrorEmail: 'Server Error. Please send message to support@dds-pro.com.pl',
    FirstName: 'FirstName',
    LastName: 'LastName',
    SelectTopic: 'Select Topic',
    Technical: 'Technical',
    General: 'General',
    Business: 'Business',
    HowWeCanHelp: 'How we can help?',
    SendCopy: 'Send me a copy',

    st8_0: 'Treatment monitoring.',
    st8_1: 'Dental practice search engine.',
    st8_2: 'Patient communication system.',
    st8_3: 'Internal communication within the practice.',
    st8_4: 'Remote access to the calendar of appointments via the application.',

    section_title_8: 'helo - Patient communication system',
    section_title_8_1: '',
    title8_0: 'Practice search engine, treatment monitoring, communication with patients and within the practice. Remote access to the calendar via the application, automation of entries in the patient\'s file. ',
    title8_1: 'Easily share electronic patient records upon request.',

    bt8_0: '',
    bt8_0_0: 'A remote system for monitoring treatment and communication in the HELO mobile application for the patient.',
    bt8_0_1: 'Internship search engine. Remote access to the calendar via the application.',
    bt8_1: 'The helo system offers completely new work possibilities. The application paired with the patient\'s account in the Ortonet program saves time and simplifies communication with the doctor/registration. Automatic recording of the history of contacts with the patient.',
    bt8_1_1: 'Reduces the number of personal visits and reception work. ',
    bt8_2: 'Selected features: ',
    bt8_3_0: 'easy communication for treatment inquiries, ',
    bt8_3_1: 'acquiring a patient interested in treatment, ',
    bt8_3_2: 'office search on "google maps" ',
    bt8_3_3: 'sending tailored instructions to the patient (automatically), ',
    bt8_3_4: 'treatment monitoring, remote, automatic surveys and contact with the patient during treatment, ',
    bt8_3_5: 'the patient takes control photos independently, ',
    bt8_3_6: 'easy control of treatment progress compared to the plan, ',
    bt8_3_7: 'online chat with the patient during designated working hours ',
    bt8_3_8: 'internal chat for practice employees. ',
    bt8_4: 'Before connecting to the patient\'s account, the ',
    bt8_4_0: '',
    bt8_4_1: 'Before connecting to the patient\'s account, the helo application works as a practice search engine. ',
    bt8_4_2: '',
    bt8_4_3: 'The free helo app is available for iPhone and Android users.',
  }
};

export const pl = {
  translations: {
    title0_1: "Witamy w ",
    title0_2: "",
    title0_3: "świecie przemysłu 4.0",
    checkOurOffer0_1: "Sprawdź naszą ",
    checkOurOffer0_2: "ofertę",
    checkOurOffer0_3: " poniżej.",

    st1_0_title_1: "Wirtualne Modele Diagnostyczne",
    st1_0_title_2: "(DDP-Ortho)",
    st1_0: "Uniwersalny system cyfrowych modeli diagnostycznych.",
    st1_1: "Gotowe analizy i narzędzia diagnostyki i planowania leczenia dla lekarzy ortodontów.",
    st1_2: "Kompatybilny z potrzebami diagnostyki implantologicznej i chirurgicznej. Biomechanika 3D zgodnie z Giorgio Fiorelli.",
    st1_3: "Opcje pracy nawigowanej po wydrukach 3D (CAD/CAM).",
    st1_4: "W pełni zgodny ze wszystkimi skanerami wewnątrzustnymi.",
    st1_5: "Platforma przetwarzania danych pacjenta.",


    section_title_2: 'Cyfrowe modele diagnostyczne',
    title1_0: 'System wirtualnych modeli diagnostycznych dla stomatologów. Modele zawierają informacje o pacjencie. ',
    title1_1: 'Dostępne są trzy typy modeli używane w zależności od potrzeb.',
    bt1_0_0: "System modeli diagnostycznych DDP-Ortho umożliwia przechowywanie diagnostyki i innych ważnych informacji o pacjencie w jednym miejscu - wewnątrz pliku z modelem.",
    bt1_0: "",
    bt1_1:"",
    bt1_2: "",
    bt1_3: "Podczas przygotowania modelu wprowadzane są detale anatomiczne, co umożliwia automatyzację wielu procedur diagnostycznych i planowania leczenia:",
    bt1_4: "",
    bt1_5:
      "",

    bt1_6: "Model Basic: zawiera analizy modeli, cefalo, notatki, zdjęcia, pomiary i stanowi kompletną dokumentację cyfrową przypadku.",
    bt1_7: "Model SemiPro: zawiera funkcjonalność wersji Basic, rozszerzoną o wirtualny setup.",
    bt1_8: "Model Pro: zawiera funkcjonalność wersji SemiPro, rozszerzoną o odwzorowanie kształtów korzeni zębów.",
    
    bt1_9: "Do użycia modeli wymagana jest bezpłatne oprogramowanie DDP-Ortho. System jest zgodny z oprogramowaniem dla chirurgów i implantologów DDS-Pro oraz systemem do zarządzania pracą praktyki Ortonet.",
    bt1_10: "",
    bt1_11: "",
    bt1_12: "",
    bt1_13: "",
    bt1_14: "",
    bt1_14_1: "",
    bt1_15_0: "Najważniejsze cele stosowania modeli DDP-Ortho:",
    bt1_15: "",
    bt1_16: "diagnostyka, planowanie i wizualizacja celów leczenia (w tym set-up 3D),",
    bt1_17: "sprawdzanie 3D poprawności biomechanicznej planowanego działania,",
    bt1_18: "tworzenie diagnostycznej dokumentacji cyfrowej pacjenta,",
    bt1_19: "projektowanie pozycji zamków ortodontycznych,",
    bt1_20: "przygotowanie planu leczenia nakładkowego,",
    bt1_21: "planowanie leczenia chirurgicznego, implantologicznego.",
    bt1_22_1: "",
    bt1_22: "Źródłem danych do produkcji modeli są skany wewnątrzustne lub wyciski / modele dostarczone do skanowania w pracowni technicznej.",
    bt1_23_0: "Modele DDP-Ortho mogą być przygotowane w ramach zlecenia w laboratorium lub bezpośrednio przez lekarza albo technika.  Oprogramowanie DTS pozwala na wiele innych zastosowań modeli.",
    bt1_23_1: "",
    bt1_23: "",


    section_title_1: 'Oprogramowanie DDP-Ortho',
    title2_0: "Bezpłatne, certyfikowane medycznie CE oprogramowanie dla specjalistów ortodontów.",
    title2_1: "Obejmuje cyfrową dokumentację pacjenta, automatyczną analizę modeli, biomechanikę 3D, cefalometrię, wirtualny set-up, wizualizację celów leczenia, planowanie leczenia nakładkowego i pośrednią metodę naklejania zamków ortodontycznych lub leczenie hybrydowe.",
    title2_2: '',
    st2_0: "Bezpłatne, certyfikowane medycznie CE oprogramowanie dla ortodontów.",
    st2_1: "Kompletna diagnostyka i planowanie leczenia.",
    st2_2: "Pełna dokumentacja cyfrowa pacjenta.",
    st2_3: "Biomechanika 3D zgodnie z Giorgio Fiorelli",
    st2_4: "Automatyczne wyliczanie analiz modeli, indywidualizowane analizy cefalo, wirtualny set-up, planowanie leczenia nakładkowego, aparatem stałym lub hybrydowo.",
    st2_5: "Zgodność EDM i Platforma E-Zdrowie.",
    st2_6: "Zgodność z wytycznymi w zakresie przekazywania cyfrowej dokumentacji medycznej pacjentom.",
    st2_7: "Wersje Windows oraz MacOS X",


    bt2_0: "DDP-Ortho stanowi kompletne rozwiązanie dla praktyk ortodontycznych.",
    bt2_1: "W jednym pliku dostępne są wszystkie elementy dokumentacji",
    bt2_2: "Oprogramowanie pracuje z modelami zapisanymi w formacie DDP-Ortho.",
    bt2_3: "Główne funkcjonalności:",
    bt2_4: "",
    bt2_5: "",
    bt2_6: "automatyczna analiza modeli,",
    bt2_7: "dowolne pomiary,",
    bt2_8: "dołączanie i edycja zdjęć,",
    bt2_9: "notatki tekstowe,",
    bt2_10: "wirtualny set-up z wieloma opcjami wizualizacji,",
    bt2_11: "wirtualny artykulator,",
    bt2_12: "wirtualny łuk twarzowy,",
    bt2_13: "planer biomechaniki 3D zgodnie z Giorgio Fiorelli,",
    bt2_14: "analizy cefalometryczne z wbudowanym edytorem,",
    bt2_15: "powiązane usługi związane ze wsparciem leczenia:",
    bt2_16_0: "planowanie położenia zamków z pośrednią metodą klejenia,",
    bt2_16_1: "kompletne rozwiązanie dla planowania i realizacji leczenia nakładkowego,",
    bt2_16_2: "platforma wymiany informacji między specjalistami (ortodonta, stomatolog, protetyk, chirurg).",
    bt2_17_0: "",
    bt2_17: "Oprogramowanie DDP-Ortho:",
    bt2_18: "Posiada certyfikację medyczną CE, jest wielojęzyczne, dostępne na system operacyjny Windows oraz Mac OS X. Dożywotnia bezpłatna licencja obejmuje także kolejne aktualizacje. DDP-Ortho objęte jest wsparciem i pomocą we wdrożeniu do pracy w gabinecie.",
    
    
    
    st3_0: "Planowanie szablonów implantologicznych w tym zygomatycznych wraz z jednoczasowymi zabiegami osteotomii, TAD’s oraz pośrednich szyn operacyjnych.",
    st3_1: "Analiza objętościowa dróg oddechowych. Bezpłatna, uniwersalna przeglądarka plików DICOM.",
    st3_2: "Oprogramowanie certyfikowane medycznie CE.",
    st3_3: "Wersja Windows oraz MacOSX",
    
    section_title_0: "Oprogramowanie DDS-Pro",
    title3_0: "",
    title3_1: "Planowanie szablonów implantologicznych oraz pośrednich szyn operacyjnych.",
    title3_2: "Zawiera bezpłatną uniwersalną przeglądarkę plików DICOM.",
    bt3_0_0: "Oprogramowanie DDS-Pro, adresowane jest do lekarzy specjalistów lub techników. Obejmuje projektowanie i wykonywanie szablonów chirurgicznych oraz pośrednich szyn operacyjnych. Umożliwia współpracę interdyscyplinarną (ortodoncja, cyfrowy „smile design”).",
    bt3_0: "",
    bt3_1:"",
    bt3_2: "Najważniejsze funkcje oprogramowania DDS-Pro:",
    bt3_3: "planowanie pozycji implantów wraz z generowaniem szablonów implantologicznych w tym zygomatycznych wraz z jednoczasowymi zabiegami osteotomii, zakotwienia tymczasowe TAD’s oraz pośrednich szyn operacyjnych,",
    bt3_4: "zaawansowane przeglądanie plików DICOM,",
    bt3_5: "filtrowanie i generowanie 3D struktur z plików DICOM,",
    bt3_6: "nawigowane wprowadzanie implantów ortodontycznych dla jednoczasowego montażu aparatów TAD's,",
    bt3_7: "narzędzie do cyfrowego projektowania uśmiechu z wax-up'em,",
    bt3_8: "tworzenie dokumentacji pacjenta (zdjęcia, analizy cefalo, pomiary),",
    bt3_9: "budowanie własnej edytowalnej biblioteki implantów,",
    bt3_10: "korzystanie z gotowych bibliotek implantów,",
    bt3_11_0: "planowanie i symulacja wyników zabiegów chirurgicznych wraz z szynami do zabiegów,",
    bt3_11_1: "wolumetryczna analiza 3D dróg oddechowych,",
    bt3_11_2: "sprawdzanie zgodności geometrii planowanych do użycia narzędzi z warunkami klinicznymi,",
    bt3_11_3: "oprogramowanie zgodne z modelami w standardzie DDP-Ortho.",

    bt3_12: "",
    bt3_13: "DDS-Pro jest certyfikowane medycznie CE, zawiera wiele wersji językowych interfejsu, pracuje na platformie Windows oraz MacOS X. Bezpłatna rejestracja i różne opcje licencji. Po rejestracji praca w trybie Viewer, może być używane jako zaawansowana przeglądarka plików DICOM. Rozszerzone licencje typu Professional. Koszty używania ograniczone są do minimum zgodnie z zasadą pay-per-use (bez żadnych stałych opłat). Komfortowa praca potwierdzona wieloma latami stabilnej pracy użytkowników na całym świecie. Pomoc techniczna oraz dostęp do dedykowanego serwisu laboratoryjnego. System jest zgodny z oprogramowaniem dla ortodontów DDP-Ortho oraz systemem do zarządzania pracą praktyki Ortonet.",
    bt3_14: "DDS-pro ",
    bt3_15: "comfortable. ",


    st4_0: "Kompletny system zarządzania dowolną praktyką stomatologiczną.",
    st4_1: "Narzędzia diagnostyki i planowania leczenia.",
    st4_2: "Opcje konsylium interdyscyplinarnego.",
    st4_3: "Dane w chmurze.",
    st4_4: "Delegowanie zadań planistycznych i klinicznych.",
    st4_5: "Kalendarz, przeglądarka DICOM.",
    st4_6: "EDM wraz z szyną P1.",
    st4_7: "Znany lekarz.",
    st4_8: "Helo",

    st4_0_1: "Management system for",
    st4_0_2: "dental / orthodontic practices.",
    
    section_title_4: 'Oprogramowanie Ortonet',
    title4_0: "Kompletny system do zarządzania dowolną praktyką stomatologiczną.",
    title4_1: "Delegowanie zadań planistycznych i klinicznych.",
    title4_2: "Obejmuje bazę danych pacjentów, analizy diagnostyczne, kalendarz, konsylium interdyscyplinarne, CRM, wszystkie opcje HELO, delegowanie zadań, dostęp do „Znanego Lekarza”, dostęp do Szyna P1 i wiele innych funkcji.",
    title4_3: "Dane są składowane w chmurze.",
    
    bt4_0: "",
    bt4_1: "Ortonet jest oprogramowaniem dedykowanym dla praktyk stomatologicznych dowolnej specjalności - zawiera typowe funkcjonalności diagnostyczne, planistyczne, wspomagania i nadzoru leczenia oraz zaawansowane specjalistyczne narzędzia diagnostyczne 3D i komunikacyjne (DDP-Ortho, DDS-Pro, HELO, DDP-Ortho-Lite).",
    bt4_2: "Wybrane funkcje:",
    bt4_3_0: "narzędzia diagnostyczne i planowania leczenia bazujące na standardzie DDP-Ortho,",
    bt4_3_1: "",
    bt4_3_2: "",
    bt4_4: "wbudowana przeglądarka plików DICOM,",
    bt4_5: "zaawansowane administrowanie przepływem pacjentów i dokumentacją,",
    bt4_6: "system delegowania zadań planistycznych i klinicznych,",
    bt4_7: "monitorowanie leczenia z aplikacją HELO,",
    bt4_8: "ułatwienia komunikacji z pacjentem lub wśród pracowników praktyki,",
    bt4_8_0: "automatyzacja procesów obsługi pacjenta, ",
    bt4_8_1: "proste zarządzanie danymi pacjenta z dostępem z dowolnego miejsca (chmura),",
    bt4_8_2: "przeglądarka plików .stl,",
    bt4_11: "pełna zgodność z wymogami Elektronicznej Dokumentacji Medycznej (raportowanie zdarzeń do szyny P1, repozytorium dokumentów).",
    bt4_9: "",
    bt4_10: "Ortonet pracuje na platformie Windows, jest wielojęzyczne, możliwe kilka wariantów licencjonowania.",

    st5_0: "Oprogramowanie dla lekarzy i techników.",
    st5_1: "Tworzenie wirtualnych modeli diagnostycznych z wielu źródeł danych.",
    st5_2: "Projektowanie nakładek, szyn do klejenia pośredniego zamków,",
    st5_2_1: "przygotowywanie modeli do wydruków 3D.",
    st5_3: "Opcja produkcji alignerów „In-House”.",
    st5_4: "Projektowanie retencji indywidualnej (wkrótce dostępne)",


    section_title_3: 'Oprogramowanie DTS	',
    title5_0: 'Oprogramowanie dla techników i stomatologów.',
    title5_1: "Pozwala na tworzenie z dowolnego źródła modeli wirtualnych dla potrzeb stomatologii,",
    title5_2: "przygotowanie leczenia nakładkowego, przygotowania klejenia pośredniego aparatów stałych, indywidualnej retencji.",
    bt5_0_0: "Oprogramowanie ",
    bt5_0: "DTS - Digital Technical Studio - oprogramowanie dla lekarzy, techników, punktów usługowych drukowania 3D, asystentów cyfrowych lub klinicystów. Jest sprawdzone na ponad 200.000 przypadków (stan na 2023 rok). Pracuje w modelu SaaS (płacisz jak używasz). Znakomita specjalistyczna alternatywa do drogich licencji i nadmiernie rozbudowanych programów. Narzędzia o intuicyjnym, wspomaganym i łatwym użyciu, podzielone na logiczne moduły. Każdy moduł może działać jako wybrane niezależne narzędzie:",
    bt5_1: "",
    bt5_2: "",
    bt5_3: "",
    bt5_4: "",
    bt5_5: "",
    bt5_6_0: "",
    bt5_6: "Dental Model Builder (DMB) - do tworzenia modelu diagnostycznego: od nieprzetworzonego skanu pliku do gotowego do wydruku modelu 3D.",
    bt5_7_0: "",
    bt5_7: "Diagnostic Model Editor (DME) - do tworzenia modeli diagnostycznych 3D z możliwością Set-Up'u.",
    bt5_8_0_0: "",
    bt5_8_0: "Indirect Bracket Placement (IPA - Indywidualnie Projektowane Aparaty) - do projektowania szyn (jigs lub płytki termoformowalne) do pośredniej metody klejenia zamków",
    bt5_8_1: "",
    bt5_8_2: "Aligners Planner (AP) - do projektowania leczenia alignerami.",
    bt5_9: "Retainer Planner (RP) – do projektowania indywidualnej retencji",
    bt5_10: "",
    bt5_11: "",
    bt5_12: "Digital Technical Studio pozwala w praktyce na samodzielną pracę z plikami wynikowymi ze skanerów wewntrzustnych (.stl, .ply, .obj). Może być użyty przez cyfrowego asystenta lub technika bezpośrednio w gabinecie. Jest też narzędziem dla współpracującego laboratorium czy usług wydruku 3D. Optymalny system płatności bez stałych kosztów (pay-per-use) gwarantuje najniższy koszt użycia. Każdy moduł może być zakupiony i używany niezależnie. Bezpłatna licencja testowa umożliwia wypróbowanie oprogramowania przed zakupem. Nasze wsparcie techniczne znakomicie ułatwia wdrożenie do pracy.",
    bt5_13_0: 'Od nieprzetworzonego',
    bt5_13_1: 'pliku ze skanera',
    bt5_13_2: 'wewnątrzustnego',
    bt5_14_0: 'do użytecznego pliku .stl',
    bt5_14_1: 'oraz wydruków 3D',
    bt5_15_0: 'Produkcja modeli',
    bt5_15_1: 'diagnostycznych',
    bt5_16: 'Basic',
    bt5_17: 'SemiPro',
    bt5_18_0: 'Projektowanie i produkcja',
    bt5_18_1: 'alignerów i IPA',




    submit: "Prześlij",
    st6_0: "Precyzyjny i efektywny w użyciu cyfrowy system transferów do pośredniego klejenia aparatów stałych. ",
    st6_1: "Projektowanie retencji indywidualnej (wkrótce dostępne)",
    st6_2: '',
    st6_3: '',
    st6_4: '',
    st6_5: '',


    section_title_5: 'Pośrednie naklejanie zamków',
    title6_0: 'IPA (Indywidualnie Projektowane Aparaty)',
    title6_1: 'Precyzyjna i efektywna w użyciu cyfrowa technika transferów do zamków ortodontycznych.',
    title6_2: '',
    title6_3: '',
    bt6_0: '',
    bt6_1: 'IPA jest techniką przygotowaną dla najbardziej wymagających lekarzy. Zgodność z modelami DDP-Ortho zapewnia automatyczne pozycjonowanie zamków na zębach z możliwością dopozycjonowania przez lekarza. Zaplanowane położenie zamków jest perfekcyjnie przenoszone na zęby pacjenta. Możliwe jest delegowanie zadań diagnostycznych i planowanie leczenia przez wyznaczone osoby pod nadzorem lekarza.',
    bt6_2: '',
    bt6_3: 'Funkcjonalności techniki IPA:',
    bt6_4: 'wizualizacja 3D zamków,',
    bt6_5: 'automatyczne pozycjonowanie zamków dopasowane do przypadku,',
    bt6_6: 'dopasowanie pozycji zamków przez lekarza zgodnie z preferencjami i planem leczenia,',
    bt6_7: 'swobodny dostęp do podstawy zamka dla uzyskania niezawodnej polimeryzacji kleju.',
    bt6_8_0: '',
    bt6_8: 'Technika IPA jest jedną związana z funkcjonalnościami oprogramowania DDP-Ortho.',
    bt6_9: '',
    bt6_10: 'Jest dostępna jako usługa laboratoryjna lub do samodzielnego przygotowania w gabinecie z zastosowaniem dostępnego oprogramowania.',
    bt6_11: '',

    st7_0: 'Gotowe nakładki do leczenia pacjentów.',
    st7_1: 'Również cyfrowy system projektowania i produkcji nakładek dla laboratoriów i praktyk lekarskich.',
    st7_2: 'Opcja własnego wytwarzania (In-House).',


    section_title_6: 'Cyfrowy system A-ligner	',
    title7_0: 'Kompletny w pełni indywidualizowany cyfrowy system do planowania i produkcji alignerów.',
    title7_1: 'Łatwy do zrobienia set-up umożliwia zrealizowanie koncepcji leczenia bez zbędengo „clean check”.',
    title7_2: '',
    title7_3: 'A-ligner może być wykorzystany jako etap leczenia hybrydowego.',
    bt7_0: '',
    bt7_1: 'A-Ligner jest cyfrowym systemem opartym na wirtualnych modelach diagnostycznych DDP-Ortho. Umożliwia planowanie leczenia nakładkowego z pełną kontrolą przesunięć zębów (szybkość, kolejność), stosowaniem zaczepów, elastików, itd.',
    bt7_2: '',
    bt7_3: 'Specyfikacja systemu:',
    bt7_4: 'pełna indywidualizacja projektowanych nakładek (wartości przemieszczeń i rotacji zębów, kształt zaczepów, sekwencje ruchów, elementy dodatkowe),',
    bt7_5: 'edytowalny na miejscu w gabinecie set-up  jest dostępny bez zbędnego kontaktu z technikiem,',
    bt7_6: 'cały proces planowania i produkcji może odbywać się w praktyce lub być zlecony wskazanej pracowni,',
    bt7_7: 'zalecane stosowanie "Retainer For Life" czyli przygotowanie każdej 5tej nakładki w serii jako retainera możliwego do długotrwałego użycia na wypadek losowego przerwania leczenia,',
    bt7_8: 'nakładki dostarczane są w krótkich seriach po 5 szt., co eliminuje problem niedopasowania nakładek w długich seriach dostarczanych z góry,',
    bt7_9: 'elastyczne płatności etapami za dostarczane serie nakładek, bez konieczności opłacania za całe leczenie z góry.',
    bt7_11_0: 'System A-Ligner jest obsługiwany w ramach bezpłatnego oprogramowania DDP-Ortho. Przygotowanie serii modeli roboczych do produkcji nakładek realizuje oprogramowanie.',
    bt7_11: 'Można zostać producentem swoich własnych nakładek.',
    bt7_12: '',

    bt7_10: '',



    ShowMore: "Więcej informacji znajdziesz tutaj.",
    Download: "Pobierz ",
    ContactUs: "Kontakt",
    Close: 'Zamknij',
    GoToTop: 'Powrót',
    Email: 'Email',
    Password: 'Hasło',
    Login: 'Login',
    ResetPassword: 'Przywracanie hasła',
    GoBack: 'Powrót',
    SendPassword: 'Wyślij hasło',

    // contact element
    FillAllFields: 'Prosze wypełnić wszystkie pola',
    Error: 'Błąd serwera',
    MessageSend: 'Wiadomość wysłana',
    ServerErrorEmail: 'Błąd serwera. Prosze wysłać wiadomość na support@dds-pro.com.pl',
    FirstName: 'Imię',
    LastName: 'Nazwisko',
    SelectTopic: 'Wybierz temat',
    Technical: 'Techniczny',
    General: 'Ogólny',
    Business: 'Business',
    HowWeCanHelp: 'Jak możemy pomóc?',
    SendCopy: 'Wyślij mi kopie',

    st8_0: 'Monitoring leczenia.',
    st8_1: 'Wyszukiwarka praktyki.',
    st8_2: 'System komunikacji z pacjentem.',
    st8_3: 'System komunikacji wewnątrz praktyki.',
    st8_4: 'Zdalny dostęp do kalendarza wizyt poprzez aplikację.',

    section_title_8: 'helo - System komunikacji z pacjentem',
    section_title_8_1: '',
    title8_0: 'Wyszukiwarka praktyk, monitorowanie leczenia, komunikacja z pacjentem oraz wewnątrz praktyki. Zdalny dostęp do kalendarza poprzez aplikację, automatyzacja zapisow na kartotece pacjenta. Łatwe udostępnianie dokumentacji elektronicznej pacjenta na jego żądanie. ',
    title8_1: '',

    bt8_0_0: 'Zdalny system do monitorowania leczenia i komunikacji w aplikacji mobilnej HELO dla pacjenta.',
    bt8_0_1: 'Wyszukiwarka praktyk. Zdalny dostęp do kalendarza poprzez aplikację.',

    bt8_0: '',
    bt8_1: 'System helo oferuje zupełnie nowe możliwości pracy. Aplikacja sparowana z kontem pacjenta w programie Ortonet oszczędza czas i upraszcza komunikację z lekarzem/rejestracją. Automatyczny zapis historii kontaktów z pacjentem. ',
    bt8_1_1: 'Zmniejsza ilość wizyt osobistych i pracy recepcji.',
    bt8_2: 'Wybrane funkcje:',

    bt8_3_0: 'łatwa komunikacja dla zapytań o leczenie,',
    bt8_3_1: 'pozyskanie pacjenta zainteresowanego leczeniem,',
    bt8_3_2: 'wyszukiwarka gabinetu na „google maps”',
    bt8_3_3: 'przesyłanie pacjentowi dopasowanych wskazówek (automatycznie),',
    bt8_3_4: 'monitoring leczenia, zdalne, automatyczne ankiety i kontakt z pacjentem w trakcie leczenia,',
    bt8_3_5: 'samodzielne wykonywanie zdjęć kontrolnych przez pacjenta,',
    bt8_3_6: 'łatwa kontrola postępów leczenia w porównaniu z planem,',
    bt8_3_7: 'czat on-line z pacjentem w wyznaczonych godzinach pracy,',
    bt8_3_8: 'czat wewnętrzny dla pracowników praktyki.',

    bt8_4: 'Przed połączeniem z kontem pacjenta aplikacja helo działa jako wyszukiwarka praktyk. Bezpłatna aplikacja helo dostępna jest dla użytkowników iPhona i Androida.',
    bt8_4_0: '',
    bt8_4_1: '',
    bt8_4_2: '',
    bt8_4_3: '',
  }
}